import momentKO from 'moment/locale/ko'

const components = {
  momentName: 'ko',
  momentLocale: momentKO
}

const locale = {
  'message': '-',
  'layouts.EmailMarketing': '이메일 마케팅',
  'layouts.application': '응용 프로그램',
  'layouts.current': '사용 중',
  'layouts.switch': '{0} 전환',
  'layouts.change': '메뉴는 {0}',
  'layouts.old.version': '왼쪽',
  'layouts.new.version': '상단',
  'layouts.new': '신규 추가',
  'layouts.edit': '편집',
  'layouts.expired': '만료 됨',
  'layouts.upgrade': '업그레이드',
  'layouts.buy': '구입',
  'layouts.onlineservice': '온라인 고객 서비스',
  'layouts.MoneyAssistant': '돈 도우미',
  'layouts.accountSettings': '계정 설정',
  'layouts.usercenter': '사용자 센터',
  'layouts.authority': '권한 관리',
  'layouts.store.authorization': '매장 승인',
  'layouts.helpcenter': '도움말 센터',
  'layouts.menusyl': '메뉴 레이아웃',
  'layouts.menusyl.top': '상위 메뉴 레이아웃',
  'layouts.menusyl.left': '사이드 메뉴 레이아웃',
  'layouts.menutransformation': '메뉴 변환',
  'layouts.logout': '시스템 종료',
  'layouts.allapplication': '모두 적용',
  'layouts.history': '최근에 열다.',
  'layouts.customscene': '{0} 사용자 정의 장면',
  'layouts.demo.tips': 'DEMO 환경에서는 이 작업을 지원하지 않으며 자체 계정을 사용하여 해당 기능을 조작할 수 있습니다.',
  'layouts.customscene.currentNoDel': '사용 중인 장면은 삭제가 허용되지 않습니다. 먼저 다른 장면으로 전환한 후 삭제하십시오.',
  'layouts.allmenu': '모든 메뉴',
  'layouts.menusearch': '키워드, 검색 메뉴를 입력하세요',
  'layouts.commonmenu': '자주 사용하는 메뉴',
  'layouts.search.placeholder': '키워드를 입력하여 메뉴를 검색하십시오.',
  'layouts.text.undefined': '데이터가 없습니다.',
  'layouts.operation.guide': '운영 가이드',
  'layouts.bookmarks': '자주 사용하는 기능 즐겨찾기',
  'layouts.bookmarks.success': '컬렉션 추가 성공',
  'layouts.bookmarks.cancel': '컬렉션 취소 성공',
  'layouts.openAll': '원터치 풀온',
  'layouts.manageFavorites': '즐겨찾기 관리',
  'layouts.ViewAll': '모든 기능 보기',
  'layout.searchKeyword': '검색 키워드',

  'version-modal.title': '전환 지침',
  'version-modal.tips': '이 스위치는 현재 버전으로 돌아 가지 않으며 포괄적 인 이해를 위해 새 버전의 도입을 확인할 수도 있습니다.',
  'version-modal.info': 'Easy ERP로 전환하면 다음과 같이 변경됩니다.',
  'version-modal.subInfo-1': '시스템 Ul 변경',
  'version-modal.subInfo-2': '메뉴 순서 변경',
  'version-modal.subInfo-3': '그에 따라 기능이 삭제 및 추가 될 수 있지만 기본 비즈니스 프로세스에는 영향을주지 않습니다.',
  'version-modal.footer': '위의 상황을 이해하고 전환하는 데 동의했습니다.',
  'version-modal.viewDemo': '전망 DEMO',

  'store-tip.title': 'A Sharp weapon for sealing a essential for in vogue goods',
  'store-tip.subtitle': '2 mins fast authorization',
  'store-tip.guide': 'High technology constructing accurate marketing operations',
  'store-tip.info-1': 'Multi-shops management<br>auto anti-associations',
  'store-tip.info-2': 'Live dates updating<br>safe and reliable',
  'store-tip.info-3': 'In time warning for<br>operation risks',
  'store-tip.remind': 'No more reminders for this login',
  'store-tip.btn': 'START AUTHORIZATION',

  'form-modal.cancel': '취소',
  'form-modal.submit': '확인',
  'form-modal.delete': '삭제',
  'form-modal.selected': '선택됨',
  'form-modal.action': '작업',
  'form-modal.third-party-abnormal': '타사 시스템이 비정상입니다!',
  'form-modal.custom.title': '장면 패널 사용자 정의',
  'form-modal.customMenuName': '장면 이름',
  'form-modal.system.title': '사용자 정의 앱 메뉴',
  'form-modal.menuname.placeholder': '사용자 정의 장면 이름을 입력하십시오.',
  'form-modal.remark.placeholder': '비고',
  'form-modal.rule.maxstring': '최대 {0} 문자열 지원',
  'form-modal.rule.maxobject': '최대 {0} 항목 선택',
  'form-modal.rule.select': '{0} 선택하세요',
  'notification-modal.title.prompt': '따뜻한 팁',
  'notification-modal.content.delete.customscene': '복구할 수 없는 장면을 삭제할지 여부',
  'notification-modal.content.maxcustomscene': '최대 30 개의 장면을 만들 수 있습니다. 폐기된 장면을 삭제하거나 기존 장면을 편집할 수 있습니다.',
  'logout.title': '종료 확인',
  'logout.content': '로그아웃을 확인하시겠습니까?',
  'logout.okText': '확인',
  'logout.cancelText': '취소',

  'tabs.close.current': '현재 탭 닫기',
  'tabs.close.right': '오른쪽 닫기',
  'tabs.close.left': '왼쪽 닫기',
  'tabs.close.all': '모두 닫기'
}

export default {
  ...components,
  ...locale
}
